// These fields allign with /CRDataNode?qualifier=type.identifier='AttributeListItem' and listType='werktijden' and notActive = 0
// values match CRDataNode 'value' property => important for matching on the backend

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();const laborRegimeNodes = [
  'ongekend',
  'Nacht',
  'Volcontinu',
  'Dag',
  'Vaste vroege ploeg',
  'Vaste late ploeg',
  'Wisselend uurrooster',
  '2-ploegen',
  '3-ploegen',
  'Weekend',
] as const;

export type LaborRegimeNode = (typeof laborRegimeNodes)[number];

export const laborRegimeOptions: {
  value: LaborRegimeNode;
  labels: { language: 'nl' | 'fr' | 'en'; label: string }[];
}[] = [
  // {
  //   value: 'ongekend',
  //   labels: [
  //     { language: 'nl', label: '' },
  //     { language: 'fr', label: '' },
  //     { language: 'en', label: '' },
  //   ],
  // },
  {
    value: 'Nacht',
    labels: [
      { language: 'nl', label: 'Nacht' },
      { language: 'fr', label: 'Nuit' },
      { language: 'en', label: 'Night' },
    ],
  },
  {
    value: 'Volcontinu',
    labels: [
      { language: 'nl', label: 'Volcontinu' },
      { language: 'fr', label: 'En continu' },
      { language: 'en', label: 'Full-Continuous' },
    ],
  },
  {
    value: 'Dag',
    labels: [
      { language: 'nl', label: 'Dag' },
      { language: 'fr', label: 'Jour' },
      { language: 'en', label: 'Day' },
    ],
  },
  {
    value: 'Vaste vroege ploeg',
    labels: [
      { language: 'nl', label: 'Vaste vroege ploeg' },
      { language: 'fr', label: 'Poste régulier en début de journée' },
      { language: 'en', label: 'Permanent early shift' },
    ],
  },
  {
    value: 'Vaste late ploeg',
    labels: [
      { language: 'nl', label: 'Vaste late ploeg' },
      { language: 'fr', label: 'Poste régulier de fin de journée' },
      { language: 'en', label: 'Permanent late shift' },
    ],
  },
  {
    value: 'Wisselend uurrooster',
    labels: [
      { language: 'nl', label: 'Wisselend uurrooster' },
      { language: 'fr', label: 'Horaire alterné' },
      { language: 'en', label: 'Alternating hours schedule' },
    ],
  },
  {
    value: '2-ploegen',
    labels: [
      { language: 'nl', label: '2-ploegen' },
      { language: 'fr', label: '2 équipes' },
      { language: 'en', label: '2-shifts' },
    ],
  },
  {
    value: '3-ploegen',
    labels: [
      { language: 'nl', label: '3-ploegen' },
      { language: 'fr', label: '3 équipes' },
      { language: 'en', label: '3-shifts' },
    ],
  },
  {
    value: 'Weekend',
    labels: [
      { language: 'nl', label: 'Weekend' },
      { language: 'fr', label: 'Week-end' },
      { language: 'en', label: 'Weekend' },
    ],
  },
];

export default laborRegimeNodes;
